import React, { useEffect, useState } from "react";
import { bool } from "prop-types";

import HideUnhideButton from "../HideUnhideButton";
import * as S from "./styled";

const HideUnhideListingComponent = props => {
  const [isHidden, setHidden] = useState(props.is_hidden);

  useEffect(() => {
    document.querySelector(
      `.HideUnhideReportBlock--width${props.is_hidden ? "262" : "238"}`
    ).style.minWidth = "auto";
  }, []);

  return (
    <S.Wrapper isHidden={isHidden}>
      <S.IconWrapper
        fill="none"
        height="12"
        viewBox="0 0 15 12"
        width="15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.50026 9.37433C5.72252 9.37433 4.28346 7.99831 4.15104 6.25456L1.69244 4.35449C1.36924 4.75995 1.07182 5.18863 0.831817 5.65738C0.778202 5.76343 0.750267 5.88061 0.750267 5.99945C0.750267 6.11829 0.778202 6.23546 0.831817 6.34152C2.10283 8.82144 4.61908 10.4993 7.50026 10.4993C8.13096 10.4993 8.7394 10.4056 9.3258 10.2542L8.10963 9.31316C7.90878 9.35196 7.70481 9.37243 7.50026 9.37433ZM14.8554 10.736L12.2644 8.73355C13.0515 8.07024 13.6988 7.25705 14.1687 6.34128C14.2223 6.23523 14.2502 6.11805 14.2502 5.99921C14.2502 5.88037 14.2223 5.7632 14.1687 5.65714C12.8977 3.17722 10.3814 1.49933 7.50026 1.49933C6.29358 1.50079 5.10649 1.80457 4.04744 2.38292L1.06572 0.0783135C1.02684 0.0480574 0.982378 0.0257597 0.934875 0.0126944C0.887372 -0.00037095 0.83776 -0.0039477 0.788874 0.00216849C0.739988 0.00828468 0.692786 0.0239739 0.649966 0.0483397C0.607146 0.0727055 0.569547 0.10527 0.539317 0.144173L0.0792389 0.736439C0.0182073 0.81495 -0.00914061 0.914489 0.00321005 1.01316C0.0155607 1.11184 0.0665984 1.20156 0.145098 1.26261L13.9348 11.9203C13.9737 11.9506 14.0181 11.9729 14.0656 11.986C14.1131 11.999 14.1628 12.0026 14.2116 11.9965C14.2605 11.9904 14.3077 11.9747 14.3505 11.9503C14.3934 11.926 14.431 11.8934 14.4612 11.8545L14.9215 11.2622C14.9825 11.1837 15.0098 11.0841 14.9974 10.9854C14.985 10.8868 14.9339 10.7971 14.8554 10.736ZM10.5495 7.40792L9.62838 6.69589C9.70595 6.4717 9.7471 6.23654 9.75026 5.99933C9.75483 5.65205 9.67789 5.30853 9.52562 4.99638C9.37335 4.68422 9.15 4.41213 8.8735 4.20196C8.59699 3.99178 8.27505 3.84939 7.93354 3.7862C7.59202 3.72302 7.24044 3.74082 6.90705 3.83816C7.04838 4.02966 7.12483 4.26132 7.12526 4.49933C7.12176 4.57853 7.10966 4.65712 7.08916 4.7337L5.36393 3.40034C5.96322 2.89953 6.71925 2.62491 7.50026 2.62433C7.94354 2.62408 8.38252 2.71121 8.7921 2.88073C9.20169 3.05026 9.57384 3.29885 9.88729 3.61229C10.2007 3.92574 10.4493 4.2979 10.6189 4.70748C10.7884 5.11707 10.8755 5.55605 10.8753 5.99933C10.8753 6.50628 10.7513 6.97878 10.5495 7.40816V7.40792Z" />
      </S.IconWrapper>
      <S.TextWrapper>
        {isHidden && "Listing hidden from search. "}
        <HideUnhideButton
          isHidden={isHidden}
          setHidden={setHidden}
          {...props}
        />
      </S.TextWrapper>
      <S.VerticalLine />
    </S.Wrapper>
  );
};

HideUnhideListingComponent.propTypes = {
  is_hidden: bool.isRequired
};

export default HideUnhideListingComponent;
